import script from "./all-employee-list.vue?vue&type=script&lang=ts&setup=true"
export * from "./all-employee-list.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__